<template>
    <div class="player-controls">
        <div class="fileName"
             v-text="playFileName">
        </div>
        <PlayerPlaylist ref="playlistRef"
                        @play="playIndex" />
        <div v-if="playlist.length > 1"
             class="play-control-row">
            <button class="player-btn"
                    @click="playPrev">
                ⏮ 이전
            </button>
            <button class="player-btn"
                    @click="playNext">
                다음 ⏭
            </button>
        </div>
        <div class="utility-control-row">
            <button class="showPlaylist-btn"
                    @click="togglePlaylist">
                ☰
            </button>
            <button class="subtitle-btn"
                    @click="toggleSubtitle">
                자막
            </button>
        </div>
        <SubtitlePanel ref="subtitlePanelRef" />
        <Transition name="player-feedback">
            <div v-if="feedbackVisible"
                 class="player-feedback">
                {{ feedbackText }}
            </div>
        </Transition>
    </div>
</template>

<script setup>
    import { ref, computed, onBeforeUnmount } from "vue";
    import { useStore } from "vuex";

    import PlayerPlaylist from "./PlayerPlaylist.vue";
    import SubtitlePanel from "./SubtitlePanel.vue";

    const playlistRef = ref(null);
    const subtitlePanelRef = ref(null);

    const store = useStore();

    const playlist = computed(() => store.state.media.playlist);
    const currentMediaFile = computed(() => store.state.media.mediaFile);
    const playFileName = computed(() => currentMediaFile.value?.name || "");

    async function playPrev() {
        await store.dispatch("media/playPrev");
    }

    async function playNext() {
        await store.dispatch("media/playNext");
    }

    async function playIndex(index) {
        await store.dispatch("media/playIndex", index);
    }

    function togglePlaylist() {
        playlistRef.value?.toggle();
    }

    function toggleSubtitle() {
        subtitlePanelRef.value?.toggle();
    }

    /*
 * Feedback
 */
    const feedbackVisible = ref(false);
    const feedbackText = ref("");

    let feedbackTimer = null;

    const showFeedback = (text) => {
        console.log(text)
        feedbackText.value = text;
        feedbackVisible.value = true;
        clearTimeout(feedbackTimer);
        feedbackTimer = setTimeout(() => {
            feedbackVisible.value = false;
        }, 800);
    };

    /*
 * Controller에서 사용할 feedback 객체
 *
 * controller:
 *
 * feedback.show("52%");
 */
    const feedback = {
        show: showFeedback
    };

    onBeforeUnmount(() => {
        clearTimeout(feedbackTimer);
    });
</script>

<style scoped>
    .player-controls {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        z-index: 100;
        pointer-events: none;
    }

        .player-controls button,
        .player-controls .play-control-row,
        .player-controls .utility-control-row {
            pointer-events: auto;
        }

    .fileName {
        position: absolute;
        display: flex;
        top: 10px;
        left: 50%;
        transform: translateX(-50%);
        margin: 0;
        max-width: 70%;
        color: rgb(255, 255, 255);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        background: rgba(0, 0, 0, 0.6);
        padding: 2px 6px;
        border-radius: 4px;
        z-index: 1;
        pointer-events: none;
    }

    .play-control-row {
        position: absolute;
        left: 12px;
        bottom: 30px;
        display: flex;
        gap: 10px;
        align-items: center;
    }

    .utility-control-row {
        position: absolute;
        right: 12px;
        bottom: 30px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-end;
    }

    /*
     * Feedback
     */
    .player-feedback {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate( -50%, -50% );
        padding: 8px 16px;
        border-radius: 8px;
        background: rgba(0, 0, 0, 0.7);
        color: white;
        font-size: 20px;
        font-weight: 600;
        z-index: 1000;
        pointer-events: none;
        user-select: none;
    }


    .player-feedback-enter-active,
    .player-feedback-leave-active {
        transition: opacity 0.15s ease;
    }


    .player-feedback-enter-from,
    .player-feedback-leave-to {
        opacity: 0;
    }
</style>